import moment from 'moment';

// The formatted date in the form "YYYY-MM-DDTHH:mm".
export const format1 = (dateString) => {
  const localDate = new Date(dateString);
  const year = localDate.getUTCFullYear();
  const month = String(localDate.getUTCMonth() + 1).padStart(2, '0');
  const day = String(localDate.getUTCDate()).padStart(2, '0');
  const hours = String(localDate.getUTCHours()).padStart(2, '0');
  const minutes = String(localDate.getUTCMinutes()).padStart(2, '0');
  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

// The formatted date in the form "YYYY-MM-DDTHH:mm:ss.sssZ".
export const format2 = (dateString) => {
  return moment(dateString).utc().toISOString();
};

// The formatted date in the form "YYYY-MM-DD".
export const format3 = (dateString) => {
  return moment(dateString).utc().format('YYYY-MM-DD');
};

// The formatted date in the form "MM/DD/YYYY".
export const format4 = (dateString) => {
  return moment(dateString).format('MM/DD/YYYY');
};

// The formatted date in the form "DD/MM/YYYY".
export const format5 = (dateString) => {
  return moment(dateString).format('DD/MM/YYYY');
};

// The formatted date in the form "MMM DD, YYYY".
export const format6 = (dateString) => {
  return moment(dateString).format('MMM DD, YYYY');
};

// The formatted date in the form "dddd, MMMM Do YYYY, h:mm:ss A" (e.g., "Tuesday, January 7th 2025, 12:00:00 AM").
export const format7 = (dateString) => {
  return moment(dateString).format('dddd, MMMM Do YYYY, h:mm:ss A');
};

// The formatted date in the form "hh:mm A" (12-hour clock with AM/PM).
export const format8 = (dateString) => {
  return moment(dateString).format('hh:mm A');
};

// The formatted date in the form "HH:mm" (24-hour clock).
export const format9 = (dateString) => {
  return moment(dateString).format('HH:mm');
};

// The Unix timestamp in seconds.
export const format10 = (dateString) => {
  return moment(dateString).unix();
};

// The Unix timestamp in milliseconds.
export const format11 = (dateString) => {
  return moment(dateString).valueOf();
};

// The formatted date in the form "ddd MMM DD YYYY HH:mm:ss GMT-ZZZZ (Pacific Daylight Time)"
export const format12 = (dateString) => {
  return dateString;
};

export const formatDate = (dateString, format) => {
  switch (format) {
    case 'format1': // "YYYY-MM-DDTHH:mm"
      return format1(dateString);

    case 'format2': // "YYYY-MM-DDTHH:mm:ss.sssZ"
      return format2(dateString);

    case 'format3': // "YYYY-MM-DD"
      return format3(dateString);

    case 'format4': // "MM/DD/YYYY"
      return format4(dateString);

    case 'format5': // "DD/MM/YYYY"
      return format5(dateString);

    case 'format6': // "MMM DD, YYYY"
      return format6(dateString);

    case 'format7': // "dddd, MMMM Do YYYY, h:mm:ss A"
      return format7(dateString);

    case 'format8': // "hh:mm A" (12-hour clock with AM/PM)
      return format8(dateString);

    case 'format9': // "HH:mm" (24-hour clock)
      return format9(dateString);

    case 'format10': // Unix timestamp in seconds
      return format10(dateString);

    case 'format11': // Unix timestamp in milliseconds
      return format11(dateString);

    case 'format12': // "ddd MMM DD YYYY HH:mm:ss GMT-ZZZZ"
      return format12(dateString);

    default:
      throw new Error(`Unsupported format: ${format}`);
  }
};

export const extractValues = (data) => {
  return Object.keys(data).reduce((acc, key) => {
    const value = data[key];
    acc[key] = value && typeof value === 'object' && 'value' in value ? value.value : value;
    return acc;
  }, {});
};
